@import "../../../../shared/scss";

:host {
  display: block;
  padding-inline: 10%;

  @include pds-media-query-max("s") {
    padding-inline: p-px-to-rem(27px);
  }

  .skeleton {
    inline-size: auto;
    border-radius: 4px;

    & phn-p-button-pure {
      text-wrap: nowrap;
      overflow: hidden;
    }
  }

  .skeleton-headline {
    inline-size: auto;
    block-size: p-px-to-rem(50px);
    background: $pds-theme-light-contrast-low;
    border-radius: 4px;
  }

  ul {
    padding-block: 0;
    padding-inline: 0;
    margin-block: 0;
    margin-inline: 0;

    & li {
      list-style: none;

      padding-block-start: $pds-spacing-fluid-medium;

      &:first-of-type {
        margin-block: 0;
        margin-inline: 0;
        padding-block-start: 0px;
      }

      .vehiclepurchase-link {
        margin-block-start: p-px-to-rem(24px);

        .menu-item-count {
          margin-inline-start: p-px-to-rem(16px);
        }
      }
    }
  }

  phn-nd-headline {
    margin-block-end: p-px-to-rem(36px);
  }
}
